const actions = {
  SET_STATE: 'settings/SET_STATE',
  CHANGE_SETTING: 'settings/CHANGE_SETTING',
  SET_THEME: 'settings/SET_THEME',
  SET_LOCALE: 'settings/SET_LOCALE',
  RELOAD_SETTINGS: 'settings/RELOAD_SETTINGS',
  // OMD-225 Phase 1: RELOAD의 조건부 쓰기/DAV 업로드를 서버 로드(loaded) 이후로 미루는 2국면 마무리.
  RELOAD_SETTINGS_FINALIZE: 'settings/RELOAD_SETTINGS_FINALIZE',
  UPLOAD_SETTINGS: 'settings/UPLOAD_SETTINGS',
  // 구버전 로컬(IndexedDB) 즐겨찾기 → email.favoriteMailboxes 1회 이전. DataManager 가 메일함 로드 후 dispatch.
  MIGRATE_FAVORITE_MAILBOXES: 'settings/MIGRATE_FAVORITE_MAILBOXES',
}

export default actions
